import React from 'react';
import { Button, Flex, Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';

import { useHtmlTranslations, useTranslations } from '../../../../contexts/LocalizationContext';

type ReturnCodesDeactivateConfirmationForOneActiveModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
};

export const ReturnCodesDeactivateConfirmationForOneActiveModal = ({
  isOpen,
  onClose,
  onAccept,
}: ReturnCodesDeactivateConfirmationForOneActiveModalProps) => {
  const translations = useTranslations();
  const htmlTranslations = useHtmlTranslations();
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{translations('return_codes_deactivate_one_active_confirmation_modal_header')}</ModalHeader>
        <ModalCloseButton />
        <Flex h="100%" display="column" p={2}>
          <Text mb={2} fontSize={'small'}>
            {htmlTranslations('return_codes_deactivate_one_active_confirmation_modal_content')}
          </Text>
          <Button width={'100%'} colorScheme={'red'} mb={2} onClick={onAccept}>
            {translations('return_codes_deactivate_one_active_confirmation_modal_confirm_button')}
          </Button>
          <Button width={'100%'} mb={2} onClick={onClose}>
            {translations('return_codes_deactivate_one_active_confirmation_modal_cancel_button')}
          </Button>
        </Flex>
      </ModalContent>
    </Modal>
  );
};
